var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.647,
    height: 19.975,
    viewBox: "0 0 16.647 19.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #aeaeae;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641",
    transform: "translate(-377.657 -29.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    className: "cls-1",
    d: "M165.458,141.34a5.177,5.177,0,0,1-1.98-4.043v-2.2a5.632,5.632,0,0,0-4.994-5.458v-.852a.834.834,0,0,0-1.665,0v.852a5.63,5.63,0,0,0-4.994,5.458v2.2a5.184,5.184,0,0,1-1.988,4.049,1.351,1.351,0,0,0-.509,1.048,1.422,1.422,0,0,0,1.457,1.381h13.733a1.422,1.422,0,0,0,1.457-1.381A1.36,1.36,0,0,0,165.458,141.34Zm0,0",
    transform: "translate(228.329 -98.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    className: "cls-1",
    d: "M220.658,355.149A3.941,3.941,0,0,0,224.514,352H216.8A3.944,3.944,0,0,0,220.658,355.149Zm0,0",
    transform: "translate(165.322 -305.366)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.25093a5cbc5ef8259beef4cba584213c.svg";
export { ForwardRef as ReactComponent };